/**
 * Consistent formatting for percentages
 * @param {String} input
 */
export default input => input ? Number(input).toFixed(1) + '%' : '-'
